import moment from 'moment'

/**
 * The news object from DB.
 * @typedef {Object} NewsSourceObject
 * @property {String} Title
 * @property {String} Content
 * @property {String} BlogTitle
 * @property {String} BlogHost
 * @property {String} AuthorName
 * @property {String|Number} PostId
 * @property {String|Number|Date} PublishDate
 * @property {String} Url
 * @property {(2|3|4)} tonality
 */

/**
 * The news object for rendering.
 * @typedef {Object} NewsObject
 * @property {String|Number} id
 * @property {String} title
 * @property {String} host
 * @property {String} group
 * @property {String} url
 * @property {(-1|0|1)} sentiment
 * @property {import('moment')} date
 */

/**
 * This mapper maps objects from server to needed in rendering info.
 * @callback NewsMapper
 * @param {NewsSourceObject} sourceObject source news {@link NewsSourceObject} to map
 * @returns {NewsObject} mapped news {@link NewsObject}
 */

/**
 * @param  {('mag'|'soc'|'pck')} type
 * @returns  {NewsMapper} News mapper {@link NewsMapper}
 */
const getNewsMapper = (type) => {
  const mappers = {
    mag: (el) => ({
      title: el.Title,
      host: el.BlogTitle,
      group: '',
    }),
    soc: (el) => ({
      title: el.Content,
      host:
        el.BlogHost == 'api-invest-gw.tinkoff.ru'
          ? 'Тинькофф Пульс'
          : el.BlogHost,
      group: el.BlogTitle,
    }),
    pck: (el) => {
      if (el.Title)
        return {
          title: el.Title,
          host: el.BlogTitle,
          group: '',
          db: el.db,
        }
      return {
        title: el.Content,
        host:
          el.BlogHost == 'api-invest-gw.tinkoff.ru'
            ? 'Тинькофф Пульс'
            : el.BlogHost,
        group: el.BlogTitle,
        db: el.db,
      }
    },
  }

  const typedMapper = mappers[type]
  // map for different types:
  return (news) => ({
    // get map function for different types
    ...typedMapper(news),
    url: news.Url,
    date: moment(news.PublishDate),
    sentiment: Number(news.tonality) - 3,
    id: news.PostId,
  })
}

export default getNewsMapper
